import PRestartLogo from '@/assets/branding/project-restart/project-restart-logo.svg';

export { PRestartLogo };
